import React from 'react';
import { TherapistPortal } from '@/components/therapist/TherapistPortal';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';

export const TherapistPortalPage = () => {
  return (
    <ProtectedRoute requiredRole="therapist">
      <TherapistPortal />
    </ProtectedRoute>
  );
};